import Vue from 'vue';
import {mx_terminal_audio_config} from '@/mixins/terminalAudioMixins'
import musicsConfig from '@/utils/musicConfig'
// element ui  拖拽指令
Vue.directive('dialogDrag', {
  bind(el, binding, vnode, oldVnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header');
    const dragDom = el.querySelector('.el-dialog');
    dialogHeaderEl.style.cursor = 'move';

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;

      // 获取到的值带px 正则匹配替换
      let styL, styT;

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if(sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
      }else {
        styL = +sty.left.replace(/\px/g, '');
        styT = +sty.top.replace(/\px/g, '');
      };

      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX;
        const t = e.clientY - disY;

        // 移动当前元素
        dragDom.style.left = `${l + styL}px`;
        dragDom.style.top = `${t + styT}px`;

        //将此时的位置传出去
        //binding.value({x:e.pageX,y:e.pageY})
      };

      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
  }
});

// v-dialogDragWidth: 弹窗宽度拖大 拖小
Vue.directive('dialogDragWidth', {
  bind(el, binding, vnode, oldVnode) {
    const dragDom = binding.value.$el.querySelector('.el-dialog');

    el.onmousedown = (e) => {

      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - el.offsetLeft;

      document.onmousemove = function (e) {
        e.preventDefault(); // 移动时禁用默认事件

        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX;
        dragDom.style.width = `${l}px`;
      };

      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
  }
});

//自定义拖拽指令
Vue.directive('drag',{
  bind(el, binding, vnode, oldVnode){
    let oDiv = el;
    oDiv.onmousedown = function(ev){
      ev.preventDefault();
      let disX = ev.clientX -oDiv.offsetLeft;
      let disY = ev.clientY - oDiv.offsetTop;
      document.onmousemove = function(ev){
        ev.preventDefault();
        let l = ev.clientX-disX;
        let t = ev.clientY-disY;
        oDiv.style.left = l+'px';
        oDiv.style.top = t+'px';
      };
      document.onmouseup = function(ev){
        ev.preventDefault();
        document.onmousemove=null;
        document.onmouseup=null;
      };
    };
  }
});

//上下拖拽
Vue.directive('drag-vertical',{
  bind(el, binding, vnode, oldVnode){
    let oDiv = el;
    oDiv.onmousedown = start;
    // 移除拖拽事件
    function  initMove(){
      document.onmouseup = function(ev){
        ev.preventDefault();
        document.onmousemove=null;
        document.onmouseup=null;
      };
    }
    // 监听弹框鼠标按下事件
    function start(ev){
      let that = this;
      // let oDiv = document.getElementsByClassName("zh-dialog-box")[0];
      ev.preventDefault();
      let disX = ev.clientX -oDiv.offsetLeft;
      let disY = ev.clientY - oDiv.offsetTop;
      //边界处理
      //body可视区的宽度
      const screenWidth = document.documentElement.clientWidth || document.body.clientWidth;
      //body可视区域的高度
      const screenHeight = document.documentElement.clientHeight || document.body.clientHeight
      const dragDomWidth = oDiv.offsetWidth  //oDiv.offsetWidth
      const dragDomHeight = oDiv.offsetHeight    //oDiv.offsetHeight
      document.onmousemove = function (ev) {
        move(oDiv,ev,disX,disY,screenWidth,screenHeight,dragDomWidth,dragDomHeight);
      } ;
      initMove();
    }
    // 移动事件
    function move(oDiv,ev,disX,disY,screenWidth,screenHeight,dragDomWidth,dragDomHeight){
      oDiv.style.margin = '0';    //设置margin  为auton
      ev.preventDefault();
  /*    if((ev.clientX-disX)<0){
        oDiv.style.left = 0 + "px";
      }else if((ev.clientX-disX)>(screenWidth - parseInt(dragDomWidth))){
        oDiv.style.left = (screenWidth - parseInt(dragDomWidth)) + "px";
      }else{
        oDiv.style.left = (event.clientX - disX) + "px";
      }*/
      if((ev.clientY-disY)<0){
        oDiv.style.top = 0 + "px";
      }else if((ev.clientY-disY)>(screenHeight - parseInt(dragDomHeight))){
        oDiv.style.top = (screenHeight - parseInt(dragDomHeight)) + "px";
      }else{
        oDiv.style.top = (ev.clientY - disY) + "px";
      }
    }
  }
});

// 提示音指令
Vue.directive('zh-terminal-voice',{
  bind(el, binding, vnode, oldVnode){
    // console.log(binding)
    let oDiv = el;
    oDiv.addEventListener('click',function () {
      switch (binding.value) {
        case mx_terminal_audio_config.clickVoice:
          musicsConfig._playClickVoice(document.getElementById(mx_terminal_audio_config.clickVoice))
          break;
        case mx_terminal_audio_config.successVoice:
          musicsConfig._playSuccessVoice(document.getElementById(mx_terminal_audio_config.successVoice))
          break;
        case mx_terminal_audio_config.selectFoodVoice:
          musicsConfig._playPleaseFoodVoice(document.getElementById(mx_terminal_audio_config.selectFoodVoice))
          break;
        case mx_terminal_audio_config.thanksVoice:
          musicsConfig._playThanksVoice(document.getElementById(mx_terminal_audio_config.thanksVoice))
          break;
        default:
          musicsConfig._playClickVoice(document.getElementById(mx_terminal_audio_config.clickVoice))
          break;
      }
    })
  }
});




// WEBPACK FOOTER //
// ./src/directive/index.js